export default {
  empty: 'No products selected',
};
